import { NumberToStringMap, StringToNumberMap } from '../../types/common';
import { AvailabilityStatus, FormStatus } from '../../types/scouting';


export const contractKeys: string[] = [
  'under6months',
  'under12months',
  'under18months',
  'under2years',
  'under3years',
  'under4years',
];


export const contractKeysToMonths: StringToNumberMap = {
  'freeAgent': 0,
  'under6months': 6,
  'under12months': 12,
  'under18months': 18,
  'under2years': 24,
  'under3years': 36,
  'under4years': 48,
};


export const monthsToContractKeys: NumberToStringMap = {
  0: 'freeAgent',
  6: 'under6months',
  12: 'under12months',
  18: 'under18months',
  24: 'under2years',
  36: 'under3years',
  48: 'under4years',
};


export const ageKeys: string[] = [
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
];


export const minConfidenceKeys: string[] = [
  '5',
  '10',
  '20',
  '30',
  '50',
  '70',
  '90',
];


export const indexKeys: string[] = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10'
];


export const playingTimeKeys: AvailabilityStatus[] = [
  'KEY',
  'ROTATION',
  'RESERVE',
  'UNKNOWN',
];


export const formKeys: FormStatus[] = [
  'IN_FORM',
  'NORMAL_FORM',
  'OUT_OF_FORM',
  'NO_FORM',
];


export const minuteAbsoluteKeys: string[] = [
  '200',
  '600',
  '1000',
  '1500',
  '2000'
];


export const minutePercentageKeys: string[] = [
  '20%',
  '40%',
  '60%',
  '80%',
  '100%'
];
